module.exports = __webpack_public_path__ + "img/img26.adb5b531.jpg";